import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../../shared/redux-store/store";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {Observable} from "rxjs/Observable";
import {MessageType} from "../../../../shared/redux-store/session/session.types";

export abstract class VisBosGuard implements CanActivate, CanActivateChild {

  constructor(protected router: Router, protected siActions: SessionActions, protected ngRx: NgRedux<IAppState>) {

  }

  public abstract canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean;

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

  protected onAccessError() {
    this.siActions.pushMessage("Sie sind nicht berechtigt, die angeforderte Seite anzuzeigen!", MessageType.ERROR, "VisBOS");
    //this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/authorization/guards/visbos.guard.ts